import { useDispatch } from 'react-redux';
import { history } from 'Store';
import { signOutAction } from 'Store/modules/auth/actions';
import { setIsLoadingAction, showModalAction } from 'Store/modules/app/actions';
import { useFetchDeleteUser } from 'Containers/Account/components/AccountPrivacy/hooks';
import { AccountDeleteProp } from 'Containers/Account/components/AccountPrivacy/components/AccountDelete/types';
import Modal from 'Components/Modal';
import { plansNameMapping, FRONT_PLANS } from 'Constants/plans';
import { TYPEFORM_DELETE_USER_URL } from 'Config';
import { WARNING_MODAL } from 'Constants/modals';
import { routes } from 'Constants/routes';
import * as Styled from './styles';
import { useGetUserCustomerData } from './hooks';

const EmbedForm = ({ setScreen }: AccountDeleteProp): JSX.Element => {
  const dispatch = useDispatch();
  const customer = useGetUserCustomerData();
  const { mutate, isLoading } = useFetchDeleteUser(() => dispatch(signOutAction()));

  const redirectFunction = (): void => {
    if (setScreen) {
      setScreen(1);
      history.replace(routes.ACCOUNT);
    }
  };
  const openModal = (): void => {
    dispatch(
      showModalAction({
        title: 'DeleteAccount.title',
        content: 'DeleteAccount.subtitle',
        link: null,
        options: {
          type: WARNING_MODAL,
          action: () => mutate({}),
          acceptText: 'DeleteAccount.cant.acept',
          cancelText: 'DeleteAccount.cancelText',
          isAcceptDanger: true,
          ternary: true,
          cancelAction: redirectFunction(),
        },
        Component: Modal,
      })
    );
  };
  if (isLoading) {
    dispatch(setIsLoadingAction());
  }

  const userPlan = customer?.activePlan?.name || FRONT_PLANS.BASIC;

  return (
    <Styled.Iframe
      id={`${TYPEFORM_DELETE_USER_URL}id_usuario=${
        customer && customer.userId
      }&plan=${plansNameMapping(userPlan)}`}
      className="my-form"
      onSubmit={openModal}
    />
  );
};

export default EmbedForm;
